<template>
  <Dropdown :open.sync="isOpen" v-bind="$attrs" :fixed="true">
    <div @click="isOpen = !isOpen">
      <slot />
    </div>
    <template #list>
      <div class="dwp-py-1" data-cy="schedule-dropdown">
        <MenuItem class="dwp-space-x-2" @click.native="today" data-cy="today">
          <CalendarIcon class="dwp-w-4 dwp-text-green-500" />
          <span>Today</span>
        </MenuItem>
        <MenuItem class="dwp-space-x-2" @click.native="tomorrow" data-cy="tomorrow">
          <SunIcon class="dwp-w-4 dwp-text-orange-500" />
          <span>Tomorrow</span>
        </MenuItem>
        <MenuItem class="dwp-space-x-2" @click.native="monday" data-cy="monday">
          <CornerDownLeftIcon class="dwp-w-4 dwp-text-primary" />
          <span>Next Monday</span>
        </MenuItem>
        <MenuItem class="dwp-space-x-2" @click.native="noDate" data-cy="no-date">
          <SlashIcon class="dwp-w-4 dwp-text-gray-500" />
          <span>No Date</span>
        </MenuItem>
      </div>
      <DatePicker
        class="dwp-px-4 dwp-pb-4 dwp--mt-2"
        @change="custom"
        @close="isOpen = false"
        :inline="true"
        :init="false"
      />
    </template>
  </Dropdown>
</template>

<script>
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import localizedFormat from "dayjs/plugin/localizedFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

import DatePicker from "@/components/ui/DatePicker.vue";
import Dropdown from "@/components/ui/Dropdown.vue";
import MenuItem from "@/components/ui/MenuItem.vue";

import {
  CalendarIcon,
  SunIcon,
  CornerDownLeftIcon,
  SlashIcon,
} from "vue-feather-icons";

export default {
  props: {
    open: Boolean,
    value: String | Date,
  },

  components: {
    DatePicker,
    CalendarIcon,
    CornerDownLeftIcon,
    SlashIcon,
    MenuItem,
    SunIcon,
    Dropdown,
  },

  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      },
    },
  },

  methods: {
    today() {
      this.$emit("change", dayjs().toDate());
      this.isOpen = false;
    },
    tomorrow() {
      this.$emit("change", dayjs().add(1, "day").toDate());
      this.isOpen = false;
    },
    monday() {
      this.$emit(
        "change",
        dayjs().add(1, "week").startOf("week").add(1, "day").toDate()
      );
      this.isOpen = false;
    },
    custom(val) {
      this.$emit("change", val);
      // this.isOpen = false;
    },
    noDate() {
      this.isOpen = false;
      this.$nextTick(() => {
        this.$emit("change", null);
      });
    },
  },
};
</script>